import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridRowModes,
  GridToolbar,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { useDispatch } from "react-redux";
import { Container, maxWidth } from "@mui/system";
import {
  AppBar,
  Dialog,
  Grid,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { Widget } from "../../components/widget/Widget";
import { Close, Payment } from "@mui/icons-material";
import { updateBin } from "../../redux/actions/bin.actions";
import CreateIcon from "@mui/icons-material/Create";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Bins(props) {
  const { bins, openDialog, handleDialog } = props;
  const [rowModesModel, setRowModesModel] = useState({});
  const [isUpdated, setIsUpdated] = useState(false);
  const [rowsData, setRowsData] = useState([]);

  const dispatch = useDispatch();

  const rows = bins?.map((item) => ({
    ...item,
    id: item?.id,
    campaign_bin_id: item?.campaign_bin_id,
    updateId: item?.id,
    bin: item?.bin,
    network: item?.network,
    campaign_id: item?.campaign_id,
    campaign_name: item?.campaign_name,
    status: item?.status,
  }));

  useEffect(() => {
    if (rows?.length > 0) {
      setRowsData(rows);
    }
  }, [bins]);

  const columns = [
    { field: "campaign_id", headerName: "Campaign Id", flex: 1 },
    {
      field: "campaign_name",
      headerName: "Campaign",
      flex: 1,
    },
    {
      field: "bin",
      headerName: "Bin",
      flex: 1,
      editable: true,
    },
    {
      field: "network",
      headerName: "Network",
      flex: 1,
      editable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      type: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<CheckIcon />}
              label="Save"
              title="Save"
              onClick={handleSaveClick(id)}
              sx={{ color: "blue" }}
            />,
            <GridActionsCellItem
              icon={<CloseIcon />}
              label="Cancel"
              title="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
              sx={{ color: "red" }}
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<CreateIcon />}
            label="Edit"
            title="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
            sx={{ color: "green" }}
          />,
        ];
      },
    },
  ];

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };

  const handleProcessRowUpdate = async (newRow) => {
    try {
      const response = await dispatch(updateBin(newRow));
      if (response?.success === true) {
        setRowModesModel("");
        setIsUpdated(true);
      }
      // handleShowAlert();
    } catch (error) {
      console.error("Error updating promo code:", error);
    }
  };

  useEffect(() => {
    if (isUpdated === true) {
      setIsUpdated(false);
    }
  }, [dispatch, isUpdated]);

  const handleCloseDialog = () => {
    handleDialog(false);
  };

  return (
    <Dialog
      fullScreen
      open={openDialog}
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Bins
          </Typography>
        </Toolbar>
      </AppBar>
      <Container
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="space-evenly"
          width="100%"
        >
          <Widget
            heading="TOTAL"
            icon={<Payment fontSize="large" color="secondary" />}
            content={bins?.length}
          />
          <Box style={{ marginTop: "3%", height: "64vh", width: "100%" }}>
            <DataGrid
              rows={rowsData}
              columns={columns}
              editMode="row"
              rowModesModel={rowModesModel}
              onRowEditStart={handleRowEditStart}
              onRowEditStop={handleRowEditStop}
              processRowUpdate={handleProcessRowUpdate}
              components={{
                Toolbar: GridToolbar,
              }}
              experimentalFeatures={{ newEditingApi: true }}
            />
          </Box>
        </Grid>
      </Container>
    </Dialog>
  );
}
